<template>
  <v-row density="compact">
    <v-col cols="12">
      <p>
        Allows you to only invest in oversold sectors, or exclude investing in a sector that is
        overbought
      </p>

      <div>
        <h6>Current Logic:</h6>
        <strong>{{
          rule.config.action == 1
            ? 'Only invest in'
            : rule.config.action == 2
              ? 'Do not invest in'
              : 'UNANSWERED'
        }}</strong>
        sectors that have <strong>{{ rule.config.above_below }}</strong> the S&amp;P TR by at least
        <strong>{{ rule.config.threshold }} percentage points</strong> over the past
        <strong>{{ GetSandPDays(rule.config.days) }}</strong> days. Restrict to these sectors only:
        <ul>
          <li v-for="s in rule.config.sector_ids" :key="s">
            {{ GetSector(s) }}
          </li>
        </ul>
      </div>
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.action"
        :items="actions"
        item-title="description"
        item-value="id"
        label="Action"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('action', $event)"
      />
    </v-col>

    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.above_below"
        :items="items"
        label="Invest/Avoid Sectors that have"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.threshold"
        density="compact"
        hide-details
        variant="outlined"
        :prefix="
          (rule.config.above_below == 'outperformed' ? 'Out' : 'Under') +
          'performance vs S&amp;P by at least:'
        "
        suffix=" perc. points (pp)"
        @update:model-value="updateConfig('threshold', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12" md="7">
      <v-select
        :model-value="rule.config.days"
        density="compact"
        hide-details
        variant="outlined"
        :items="stocks_vs_sp_months"
        item-title="text"
        item-value="value"
        prefix="over the past"
        label="Trading days"
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>

    <v-col cols="12">
      <v-select
        :model-value="rule.config.sector_ids"
        :items="comparisons"
        variant="outlined"
        item-title="description"
        item-value="id"
        density="compact"
        chips
        label="Sector(s)"
        multiple
        @update:model-value="updateConfig('sector_ids', $event)"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      items: ['outperformed', 'underperformed'],
      actions: [
        { id: 1, description: 'Only invest in' },
        { id: 2, description: 'Do not invest in' }
      ],
      editedTa: {
        enabled: true,
        above_below: 'outperformed',
        threshold: 5,
        sector_ids: [5593],
        action: 2,
        days: 12,
        long_short: 'long'
      },
      defaultTa: {
        enabled: true,
        above_below: 'outperformed',
        threshold: 5,
        action: 2,
        sector_ids: [5593],
        days: 12,
        long_short: 'long'
      },
      stocks_vs_sp_months: [
        { text: '20 trading days', value: 1 },
        { text: '60 trading days', value: 3 },
        { text: '120 trading days', value: 6 },
        { text: '180 trading days', value: 9 },
        { text: '240 trading days', value: 12 },
        { text: '480 trading days', value: 24 }
      ],
      comparisons: [
        { id: 206787, description: 'Communications (XLC)' },
        { id: 5962, description: 'Consumer Discretionary (XLY)' },
        { id: 6764, description: 'Consumer Staples (XLP)' },
        { id: 4145, description: 'Energy (XLE)' },
        { id: 5963, description: 'Financials (XLF)' },
        { id: 5961, description: 'Health Care (XLV)' },
        { id: 4180, description: 'Industrials (XLI)' },
        { id: 5910, description: 'Materials (XLB)' },
        { id: 191504, description: 'Real Estate (XLRE)' },
        { id: 5593, description: 'Technology (XLK)' },
        { id: 5018, description: 'Utilities (XLU)' },
        { id: 7303, description: 'Transports (IYT)' }
      ]
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},
  mounted() {
    if (
      !this.rule.config ||
      !this.rule.config.rule_type ||
      this.rule.trend != 'sector' ||
      (!this.rule.config.type && !this.rule.config.days)
    ) {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    },
    GetSandPDays(id) {
      var found = null
      for (var i = 0; i < this.stocks_vs_sp_months.length; i++) {
        var s = this.stocks_vs_sp_months[i]
        if (s.value == id) {
          found = s.text
          break
        }
      }
      return found
    },
    GetSector(id) {
      var found = null
      for (var i = 0; i < this.comparisons.length; i++) {
        var s = this.comparisons[i]
        if (s.id == id) {
          found = s.description
          break
        }
      }
      return found
    },
    IsValid() {
      var r = this.rule.config
      return r.sector_ids.length > 0
    }
  }
}
</script>
